<template>
  <div class="DeepInfo flex flex-col h-screen bg-orange">
    <div class="logo-header-container ml-8 mt-8">
      <div class="logo-header flex">
        <div class="logo w-32">
          <img class="w-full" src="https://blissing.s3-us-west-1.amazonaws.com/img/blissing_UN_logo_icon_v02.png" alt="blissing blue image logo">
        </div>
        <div class="flex flex-col ml-4">
          <img class="blissing-logo" src="https://blissing.s3-us-west-1.amazonaws.com/img/BLISSING_BW.png" alt="blissing text logo">
          <span class="text-2xl text-left ml-1 font-bold border-4ads border-b-4 leading-none self-start mt-1">DEEP INFO FOR EXPERTS</span>
        </div>
      </div>
    </div>

    <ProcessIndex v-if="section == 'index'" />
    <ProcessSubOne v-if="section == 'sub-process-one'"
    :pdfUrlOne="pdfBaseUrl + pdfs.process_1_potentials"
    :pdfUrlTwo="pdfBaseUrl + pdfs.process_1_estimated"/>
    <ProcessSubTwo v-if="section == 'sub-process-two'" :pdfUrl="pdfBaseUrl + pdfs.process_2" />
    <ProcessSubThree v-if="section == 'sub-process-three'" :pdfUrl="pdfBaseUrl + pdfs.process_3" />
    <ProcessSubFour v-if="section == 'sub-process-four'" :pdfUrl="pdfBaseUrl + pdfs.process_4" />
    <ProcessSubFive v-if="section == 'sub-process-five'" :pdfUrl="pdfBaseUrl + pdfs.process_5" />

    <div v-if="section == 'index'" class="bottom-text">
      <h1 class="font-bold italic">Part 4: Process Information</h1>
    </div>

    <div @click="goBack()" class="h-16 w-16 absolute bottom-0 ml-10 mb-10 z-50">
      <img class="arrow up cursor-pointer" src="https://blissing.s3-us-west-1.amazonaws.com/img/Arrow-up.png" alt="arrow up">
    </div>

    <Navigation textColor="black"/>

  </div>
</template>

<script>
import ProcessIndex from "@/components/deepinfo/process/Index.vue";
import ProcessSubOne from "@/components/deepinfo/process/SubOne.vue";
import ProcessSubTwo from "@/components/deepinfo/process/SubTwo.vue";
import ProcessSubThree from "@/components/deepinfo/process/SubThree.vue";
import ProcessSubFour from "@/components/deepinfo/process/SubFour.vue";
import ProcessSubFive from "@/components/deepinfo/process/SubFive.vue";
import Navigation from "@/components/Navigation.vue";
import {mapState} from "vuex";

export default {
  name: "DeepInfoProcess",
  components:{
    ProcessIndex,
    ProcessSubOne,
    ProcessSubTwo,
    ProcessSubThree,
    ProcessSubFour,
    ProcessSubFive,
    Navigation
  },
  data(){
    return{
      section: 'index',
      pdfs:{
        process_1_potentials: 'deep_info/Advertising+-+How+to+Make+Money.pdf',
        process_1_estimated: 'deep_info/AD_REVENUES_ESTIMATED.mp4',
        process_2: 'deep_info/IAI+-+Art%2C+Music%2C+Mystic.pdf',
        process_3: 'deep_info/Research.pdf',
        process_4: 'deep_info/Mind+Design+-+Neuro+Lab.pdf',
        process_5: 'deep_info/Glossary.pdf',
      }
    }
  },
  methods:{
    showCard(card){
      if (card != 'deep-info-main-menu') {
        this.section = card;
      } else {
        this.$router.push({name: 'DeepInfo'});
      }
    },
    goBack(){
      if (this.section == 'index') {
        this.$router.go(-1);
      }else {
        this.showCard('index');
      }
    }
  },
  computed: {
   ...mapState(["pdfBaseUrl"])
 },
  mounted(){
    Event.$on('clickedCard', (data) => {this.showCard(data)});
  }
}
</script>

<style lang="css" scoped>
.blissing-logo{
  width: 20rem;
}
</style>
